
import XImg from 'vux/src/components/x-img/index.vue'

import global from '../../../static/js/global.js'
export default {
components: {
XImg
},
data(){
return{
src:global.imgUrl + '/image/applogo.jpg'
}
},
}



// WEBPACK FOOTER //
// ./src/components/newComponents/about.vue